<script>

import { Line } from 'vue-chartjs'
import core from '../../plugins/core';

var yellowColor = "#fbc02d"
var blueColor = 'rgba(54, 162, 235, 1)'
var purpleColor = '#FFFFFF' //'#A534D9'

export default {
    extends: Line,
    props: [ 'walletMain', 'walletDeposit', 'monyConvertValue', 'inPRT' ],
    data() {
      return {
        chartData: {
          labels: [],
          datasets: [
            {
                label: 'ù',
                lineTension: 0,
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: blueColor,
                borderWidth: 2,
                pointRadius: 2,
                pointBackgroundColor: blueColor,
                pointBorderColor: blueColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: blueColor,
                pointHoverBorderColor: blueColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes1'
            },
            {
                label: 'PRT',
                lineTension: 0,
                // backgroundColor: "rgba(251, 192, 45, 0.24)",
                borderColor: yellowColor,
                borderWidth: 2,
                pointRadius: 2,
                pointBackgroundColor: yellowColor,
                pointBorderColor: yellowColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: yellowColor,
                pointHoverBorderColor: yellowColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes2'
            },
            {
                label: 'moyenne',
                lineTension: 0,
                // backgroundColor: "rgba(251, 192, 45, 0.24)",
                borderColor: purpleColor,
                borderWidth: 4,
                pointRadius: 0,
                pointBackgroundColor: purpleColor,
                pointBorderColor: purpleColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: purpleColor,
                pointHoverBorderColor: purpleColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes2'
            },
          ]
        },
        chartOptions: {
            maintainAspectRatio: false,
            title: { display: false },
            scales: {
                yAxes: [
                {
                    id: 'yAxes1',
                    type: 'linear',
                    position: 'left',
                    ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 8,
                        callback: function(value) {
                            return value + " ù";
                        }
                    }
                },
                {
                    id: 'yAxes2',
                    type: 'linear',
                    position: 'right',
                    ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 8,
                        callback: function(value) {
                            return value + " PRT";
                        }
                    }
                }
                ]
            },
            legend: {
                display: false
            }
        },
      }
    },
    mounted: function(){  
        this.calcWalletMainValues()
        this.renderChart(this.chartData, this.chartOptions)

        this.$root.$on('updateChartTuto', () => { 
            //console.log("addToChartWallet", data, label)
            this.calcWalletMainValues()
            this.$data._chart.update() 
        })
    },
    beforeDestroy: function() {
        this.$root.$off('updateChartTuto',)
    },
    methods: {
        calcWalletMainValues: function(){
            //console.log("calcWalletMainValues", this.walletMain.transactions.length)
            let val = []
            let val2 = []
            let lbls = []
            let moyenne = []
            let totalUnity = 0
            //console.log("transaction", this.walletMain.transactions.length)
            this.walletMain.transactions.forEach((transaction, t) => {
                //console.log("transaction", transaction.monyConvertValue, transaction.nextConvertValue)
                totalUnity += transaction.amountUnity 
                let totalMony = core.convertUnityMony(totalUnity, transaction.nextConvertValue)
                val.push(totalMony)
                val2.push(totalUnity)
                let lbl = transaction.walletFrom == "NOWHERE" ? ("J+" + t) : (transaction.amountMony).toFixed(4) + "PRT"
                if(this.walletMain.stateAccount) lbl = "/"
                lbls.push(lbl)
                moyenne.push((365.25/12).toFixed(4))
                //console.log("totalMony", totalMony)
            })
            this.chartData.labels = lbls
            this.chartData.datasets[1].data = val
            this.chartData.datasets[0].data = val2
            this.chartData.datasets[2].data = moyenne
        },
    }
  }
</script>